// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"4db31328","787":"593e0f98"}[chunkId] + ".chunk.js";
};